"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(require("./get-patient"), exports);
__exportStar(require("./get-patient-remotely"), exports);
__exportStar(require("./get-patients"), exports);
__exportStar(require("./get-patients-remotely"), exports);
__exportStar(require("./register-patient"), exports);
__exportStar(require("./register-patient-remotely"), exports);
__exportStar(require("./patient"), exports);
__exportStar(require("./delete-patient"), exports);
__exportStar(require("./delete-patient-remotely"), exports);
__exportStar(require("./get-patientByCpfRg"), exports);
__exportStar(require("./get-patientByCpfRg-remotely"), exports);
__exportStar(require("./get-patientByCpf"), exports);
__exportStar(require("./get-patientByCpf-remotely"), exports);
__exportStar(require("./get-patientByRg"), exports);
__exportStar(require("./get-patientByRg-remotely"), exports);
